/** jsdom locks `window.location.reload`, so tests replace this seam instead. */
export const reloadPage = () => window.location.reload();
